import React, { useState } from "react";
import axios from "axios";

const VinLookup = () => {
    const [vin, setVin] = useState("");
    const [vinData, setVinData] = useState(null);
    const [vinError, setVinError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setVin(e.target.value);
    };

    const handleVinLookup = async () => {
        if (!vin) {
            setVinError("Please enter a VIN.");
            return;
        }

        setLoading(true);
        setVinError("");
        setVinData(null);

        try {
            // Fetch VIN data using the DecodeVinValuesExtended endpoint
            const response = await axios.get(
                `https://vpic.nhtsa.dot.gov/api/vehicles/DecodeVinValuesExtended/${vin}?format=json`
            );
            const results = response.data.Results[0];
            setVinData(results);
        } catch (error) {
            console.error("Error fetching VIN data", error);
            setVinError("Failed to fetch VIN data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const renderData = () => {
        if (!vinData) return null;

        // Filter out empty or null values
        const filteredData = Object.entries(vinData).filter(
            ([key, value]) => value && value !== "Not Applicable" && value !== "N/A"
        );

        return (
            <div className="mt-6">
                <h2 className="text-xl font-semibold mb-4">Vehicle Information</h2>
                <table className="table-auto border-collapse border border-gray-300 w-full text-sm">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="border border-gray-300 px-4 py-2 text-left">Variable</th>
                            <th className="border border-gray-300 px-4 py-2 text-left">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map(([key, value], index) => (
                            <tr key={index} className="odd:bg-white even:bg-gray-50">
                                <td className="border border-gray-300 px-4 py-2">{key}</td>
                                <td className="border border-gray-300 px-4 py-2">{value}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    return (
        <div className="h-full overflow-scroll p-6 bg-gray-50">
            <h1 className="text-2xl font-bold mb-4 text-center">VIN Lookup</h1>
            <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">VIN:</label>
                <input
                    type="text"
                    value={vin}
                    onChange={handleChange}
                    placeholder="Enter VIN"
                    className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
            </div>
            <button
                type="button"
                onClick={handleVinLookup}
                className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition"
            >
                {loading ? "Loading..." : "Lookup VIN"}
            </button>
            {vinError && <p className="text-red-500 mt-2">{vinError}</p>}
            {renderData()}
        </div>
    );
};

export default VinLookup;